module.exports = __webpack_public_path__ + "img/037-file-empty.1813da65.svg";